export default __webpack_public_path__ + "static/media/Rebel's Longbow.545c503c.jpg";